import React, { useEffect, useRef, useState } from "react";
import { Upload, RotateCcw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const refreshTabIcon = (v) => document.querySelectorAll("link[rel~='icon'], link[rel='apple-touch-icon']").forEach((l) => {
  l.href = `${l.href.split("?")[0]}?v=${v || Date.now()}`;
});

export default function FaviconField() {
  const ref = useRef();
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings").then((r) => setV(r.data.favicon_version || "")).catch(() => {}); }, []);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", f);
      const r = await api.post("/admin/favicon", fd);
      setV(r.data.favicon_version); refreshTabIcon(r.data.favicon_version); toast.success("Website icon updated");
    } catch (err) { toast.error(err.response?.data?.detail || "Upload failed"); } finally { setBusy(false); }
  };
  const reset = async () => { await api.delete("/admin/favicon"); setV(""); refreshTabIcon(); toast.success("Default icon restored"); };
  const src = (n) => `${process.env.REACT_APP_BACKEND_URL}/api/favicon/${n}?v=${v || "default"}`;

  return (
    <div data-testid="favicon-field">
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex items-end gap-3 p-3 rounded-xl bg-black/30 border border-white/10">
          <img src={src("icon-192.png")} alt="" className="w-16 h-16 rounded-xl" data-testid="favicon-preview-192" />
          <img src={src("icon-48.png")} alt="" className="w-8 h-8" />
          <img src={src("icon-32.png")} alt="" className="w-4 h-4" />
        </div>
        <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-xs text-white/70" title="Browser tab preview">
          <img src={src("icon-32.png")} alt="" className="w-4 h-4" /> 7 Legendary — Future of Gaming
        </div>
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <button onClick={() => ref.current?.click()} disabled={busy} data-testid="favicon-upload-btn" className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-white/10 text-white text-sm font-semibold hover:bg-white/20 disabled:opacity-60">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />} Upload icon
        </button>
        {v && <button onClick={reset} data-testid="favicon-reset-btn" className="inline-flex items-center gap-1.5 text-sm text-white/60 hover:text-white"><RotateCcw size={14} /> Use default</button>}
        <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" hidden onChange={upload} data-testid="favicon-input" />
      </div>
      <p className="mt-2 text-xs text-white/40">Square PNG/JPG, at least 512×512. Applied instantly to the browser tab and Google search results (Google may take a few days to refresh).</p>
    </div>
  );
}
